export const DAY_SECOND = 86400;
export const ACTION_MAP = {
  1: '取',
  2: '送',
};

export const COMMON_ORDER_STATUS = [
  { text: '待处理', label: 6000 },
  { text: '已指派', label: 7020 },
  { text: '已到店', label: 7030 },
  { text: '配送中', label: 8010 },
  { text: '配送失败', label: 8800 },
  { text: '已完成', label: 9100 },
  { text: '已取消', label: 10000 },
];

export const ORDER_STATUS = {
  distribute: 10,
  confirm: 20,
  arriveshop: 30,
  pickup: 40,
  finish: 50,
  cancel: 70,
};

export const ORDER_STATUS_NAME = {
  10: '指派',
  20: '已接单',
  30: '已到店',
  40: '配送中',
  50: '完成',
  70: '取消',
  100: '完毕',
};

export const ORDER_TYPES = ['全部', '已完成', '未完成', '未来单'];
export const MARKER_TYPES = ['商户', '用户', '骑手', '取餐', '完成'];

export const RIDER_STATUS_MAP = {
  1: { name: '未排班', color: '#EEEEEE' },
  2: { name: '离岗', color: '#FFCC99' },
  3: { name: '小休', color: '#CCCCFF' },
  4: { name: '掉线', color: '#FFFFCC' },
  5: { name: '在店', color: '#99FF99' },
  6: { name: '在岗', color: '#CCFFFF' },
};

export const COLOR_GALAXY = [
  '#F07B3F',
  '#FFD96A',
  '#B7E576',
  '#83CC61',
  '#45ADA8',
  '#74DBEF',
  '#32B1FF',
  '#0074E4',
  '#8C82FC',
  '#B693FE',
  '#FF9DE2',
  '#F67280',
  '#F34949',
];

export const DISPATCH_MODE = {
  1: '分组',
  2: '并单',
  3: '手动指派',
};

export const DISPATCH_TYPE = {
  1: '商圈调度',
  2: '驻店中餐调度',
  3: '驻店西餐调度',
};

export const NEW_DISPATCH_TYPE = {
  SHOP: '驻店',
  AOI: '商圈',
  ALL: '',
};

// 高德地图样式
export const MAP_STYLE = 'amap://styles/40b9cde39cb2c22a43b0e3aa213cbb6f';

// 地图显示内容
export const MAP_FEATURES = ['road', 'point'];

// 商圈餐厅的标记图
export const AOI_STORE_IMG = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAC10lEQVR4AWIAAb/Jr6W8JwEqJweYa44wCp93dvd+rm3bQd0GZYzajVnbQW3btoLa4W/b+Mx71zvv6dxJfvskz+pMntXM8gnnPrOCz/zcT7JkVRbsHk558Wsr9Pznlum5Ty/R+7/t1aIoaKuCA6MZr3/Xd3rhc4ufuvgLBnAxDlSa3iZhy0nUCp0tBiB8SEBIaQLAs+p6FAraQhEQYkx0Y9a99FQv9GbiDKiFq9HVarB2iI2nFgDtNYGqwoS1kDCneWGjZ/6eBPemFwq2a/NCL+cmbHREgaAtMiDhUAdOgEtoGO0HE+xOKgRAV4us88rgxo1BKGh3Y31NgsARRz80o2aI8BQxYQByg1dWBzf10gL/vb1PLQjde++dO/YOYatrKPAxRtDhBlUKr7G64ataehdEndDd3AhAVZgg2hWsDg3LPD4ShUABtLPAyFCEFWgDSYwkFkXaQJkryqapUPQOtnhpLRSwPoQyy4BAYMJWQZUcaaoyeanIUyb1Bg5oHcNutRTtUqLdlNillmHvzgxxksCWKQ7eIUeHZOh0XSsKHL59hvZiBEmcIo+HB5hlvwOk3Pf+xBfe+mYS581dzJHhYS5etMQzPDTIeYu7+eL30/jJb7M4PDzC7pUruWjhEi5dspSNxhj//GcKX/1mCl/7cuKdWJUqHbqCrKjWsqoqJknSxB+rrWiLhFpmvi/L0okazPOc1lrfu5J5OnrlauHo6OjVJL3A4Qd63LHbMM4rNhxsyj3+xqtppumAi8FGQhJwWAI/LsrxyPgGHnU0j63Cd5uK2WRhgP+6C3yzIENPoh537K+5btuFqsC0gRKAIBB4RATTByvfbbOwULppEuHsvWuolIBXA5klFFsWCtZLIIKVDYvZwxWMrK4h2GRktZA08QZ3EmAkV/Qm6o+3kNWO0KtF/3Rza3IYRieUZbl63SoVgcHqiABWFUmSrn7SKIqQpunkpgMu/wO1dQ/7145+kwAAAABJRU5ErkJggg==';
// 驻店的标记图
export const STORE_IMG = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAACxklEQVR4AZWSA6y1RxCGn5ndg3sPa9u27Zi1G9c2gtqMjT9q2Aa1G9W23V7z4NuZNt+5+ur/TZbvzLMUAL/g5A3ppsfJ+nvaIceQzjkPUoKxUUq3XOXMToMZvts+ZOddKWiA6UninTe6/PYTiN7HsXK1nPhoUgC6dgUx7okDwzUWJTiISF4QISXBHXAolWB4WHAElYt5hgMA1E84IQAH4wYiUG+wJHcKsrQ8XypDrQ5mEEIEPxBAaaUNcN8IdxDwWr0ALEBTtjwul/PTDGIA190BFNFNUVkPcxCBWgP8b3YoQEosm+D1JgiAg/v2f5y2rKjsj0oAQASv1wEHpAhEIBk4y2q1QYTBZnwjWmwU3exMEQEADUh1GFICd2TxiCIg5GOxDEwGpdEC0cXcdfG0TexNTO4A4G4QAv2RETxWBqCpScoTYzA3B6mPbbol6deRpUfRn34gjI9CjFRCoJPSDrE7PfVIcL/Uu/PS22ZH5tprE6s1MKPfUobWXIfq929gITC7+TZYrUU0z8e+1vrUOx1K3Q6z5fIIofSsOMhvN132oK67wYXZIUfDRpswPz0D+ZesYWO/kZ5/El9jLapHHEen1yfL0uD9Wk36rzxP9ctPyYJcs+4FV98pAD93s1ObpbDKOvODnfX7AJRKJVClDygQ3bHc7+VfL8ZIUiWUK8z1+qevM1RZpQCVudlQcQOzRVBeBAhuWGZkfUNxVIVKpUoIAXdHU6KKEzsdBYgMlJtA8dsBT36XeH3EANh7beXojQOBQmwhN/IPCgqv/mQ89m0iCAB5v14SDt1AyYy/lfIPSgbvjxs4BBkUAT6YsNyD1QT2zNmqHTl0ozKZOQAq0EnOP/OWjywURRDhx5nENzOOisA/BVK0FEBEZ0Wk6ApMdI1f5gwV/lUikjNYBtrzMzMzb4to/mkXC/hfYO5eiBFRBrn2PMDv2RJhVD/b6C0AAAAASUVORK5CYII=';

// 共享单元范围颜色
export const AOI_COLOR = '#77B6FF';

// 共享单元文字颜色
export const AOI_COLOR_TEXT = '#77B6FF';

// 订单流向图的轨迹颜色 -> 驻店
export const ORDER_FLOW_STORE = 'rgba(255,50,100,0.6)';

// 订单流向图的轨迹颜色 -> 商圈
export const ORDER_FLOW_AOI = 'rgba(41,144,255,0.6)';



// WEBPACK FOOTER //
// ./src/common/constant.js